export enum CancelType {
  CANCEL = 'CANCEL',
  CLOSE = 'CLOSE'
}
